<template>
    <ReportAccident></ReportAccident>
</template>

<script>
import { defineAsyncComponent } from "vue";

const GuestLayout = defineAsyncComponent(() =>
    import("../../Layouts/GuestLayout.vue")
);
const ReportAccident = defineAsyncComponent(() =>
    import("../../components/Safety/ReportAccident.vue")
);

export default {
    name: "ReportAccidentUnauth", //The name you are in should not equal the name of the component you are importing.
    components: { ReportAccident, GuestLayout },
    layout: [GuestLayout],
};
</script>
